import React, { useCallback, useEffect } from "react";
import { wire } from "react-hot-wire";

import { DrawerService } from "services/drawer/Drawer.service";

import { drawers } from "components/common/drawers-container";

function DrawersContainer({ drawerService }: { drawerService: DrawerService }) {
  const [, updateState] = React.useState<Record<string, unknown> | undefined>();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    return drawerService.addListener(forceUpdate);
  }, [forceUpdate, drawerService]);

  return drawerService.drawers.map(drawer => {
    const Drawer = drawers[drawer.name];

    return (
      <Drawer
        key={drawer.props.id || drawer.name}
        {...drawer.props}
        drawerProps={{
          name: drawer.name,
          ...drawer.props.drawerProps
        }}
      />
    );
  });
}

export default wire(["drawerService"], DrawersContainer);
